module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-8de8d30e0f63f9efab317f3d72e99cfc.png";